import React, {useEffect, useState} from "react";

import './NotificationPanelList.scss'
import {useRecoilValue} from "recoil";
import {grpcNotificationServiceSelector} from "../../state/grpc";
import {ClickableTile, Loading} from "@carbon/react";
import {useNavigate} from "react-router-dom";
import PubSub from "pubsub-js";
import TimeSince from "../../utils";
import PropTypes from "prop-types";

const NotificationPanelList = ({notificationReadCallback}) => {
  const notificationService = useRecoilValue(grpcNotificationServiceSelector)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [notifications, setNotifications] = useState(null)
  const navigate = useNavigate();
  const [page, setPage] = useState(1)
  const [loadMore, setLoadMore] = useState(true)
  const pageSize = 10

  useEffect(() => {
    const req = new proto.api.ListNotificationRequest()
    const pageReq = new proto.api.PageRequest()
    pageReq.setSort("datetime desc")
    pageReq.setSize(pageSize)
    pageReq.setPage(page)
    req.setPagination(pageReq)
    notificationService.listNotifications(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        const list = resp.toObject().notificationsList
        if (list.length < pageSize) {
          setLoadMore(false)
        }
        if (notifications == null) {
          setNotifications(list)
        } else {
          setNotifications((currentState) => [
            ...currentState,
            ...list,
          ])
        }
        setLoading(false)
        setError(false)
      }
    })
  }, [page])

  useEffect(() => {
    if (notifications == null) {
      return
    }
    const token = PubSub.subscribe('USER_EVENT', handleUserEvent)
    return () => {
      PubSub.unsubscribe(token)
    }
  }, [notifications])

  const handleUserEvent = (msg, notification) => {
    if (notifications.filter(it => it.id === notification.id).length > 0) {
      return
    }
    setNotifications((currentState) => [
      ...currentState,
      notification,
    ])
  }

  if (loading || notifications == null) {
    return (
      <div className="notifications__centered-panel">
        <Loading withOverlay={false}/>
      </div>
    )
  }

  if (error) {
    return (
      <div className="notifications__centered-panel">
        <span>Si è verificato un errore durante il caricamento delle notifiche. Riprovare più tardi</span>
      </div>
    )
  }

  const handleNotificationRead = (notification) => {
    // this notification has already been read
    if (notification.read) {
      notificationReadCallback(true)
      navigate(notification.actiontype + "/" + notification.actionrefid)
      return
    }
    const req = new proto.api.SaveNotificationRequest()
    const notReq = new proto.api.Notification()
    notReq.setId(notification.id)
    notReq.setRead(true)
    req.setNotification(notReq)
    notificationService.updateNotification(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
      } else {
        setNotifications(notifications.map((row) => ({
          ...row,
          read: row.id === notification.id ? true : row.read
        })))
        notificationReadCallback(false)
      }
    })
    navigate(notification.actiontype + "/" + notification.actionrefid)
  }

  return (
    <div className="notifications__list_container">
      {
        notifications.map((it) =>
          <ClickableTile
            key={it.id}
            onClick={() => handleNotificationRead(it)}
            className={"notifications__list_item" + (it.read ? " read" : " unread")}>
            <div className="notifications__list_item__title">
              <span className="notifications__list_item__title_user">{it.sender}</span> ti ha inviato un messaggio
            </div>
            <p className="notifications__list_item__content">
              {it.content}
            </p>
            <p className="notifications__list_item__datetime" title={it.datetime}>
              {TimeSince(it.datetime)} fa
            </p>
          </ClickableTile>
        )
      }
      {
        loadMore &&
        <ClickableTile
          key="notifications__list_item__load_more"
          onClick={() => {
            setPage(page + 1)
          }}
          className="notifications__list_item__load_more">
          <span>Carica più elementi</span>
        </ClickableTile>
      }
    </div>
  )
}

NotificationPanelList.propTypes = {
  notificationReadCallback: PropTypes.func.isRequired,
}

export default NotificationPanelList